module.exports = __webpack_public_path__ + "static/media/notfound.e9cf698f.svg";